import { createApp } from 'vue'
import { router } from './router'
import { createPinia } from 'pinia'
import App from './App.vue'
import '@icon-park/vue-next/styles/index.css'
import 'prosemirror-view/style/prosemirror.css'
import 'animate.css'

import '@/assets/styles/prosemirror.scss'
import '@/assets/styles/font.scss'
import 'primeicons/primeicons.css'

import Icon from '@/plugins/icon'
import Directive from '@/plugins/directive'
import VueCookies from 'vue-cookies'
import Vue from 'vue'
import i18nCountries from '@/plugins/i18nCountries'

import '@/assets/styles/theme.css'
import 'primevue/resources/primevue.min.css'
import 'bootstrap/dist/css/bootstrap.css';
import VueTimepicker from 'vue3-timepicker'
import 'vue3-timepicker/dist/VueTimepicker.css'



import PrimeVue from 'primevue/config'
import InputText from 'primevue/inputtext';
import Button from 'primevue/button'
import InputNumber from 'primevue/inputnumber'
import InputGroup from 'primevue/inputgroup'
import InputGroupAddon from 'primevue/inputgroupaddon'
import Dropdown from 'primevue/dropdown'
import SelectButton from 'primevue/selectbutton'
import ToggleButton from 'primevue/togglebutton'
import InputSwitch from 'primevue/inputswitch'
import Checkbox from 'primevue/checkbox'
import Chip from 'primevue/chip'
import Textarea from 'primevue/textarea'
import AutoComplete from 'primevue/autocomplete'
import Toolbar from 'primevue/toolbar'
import OverlayPanel from 'primevue/overlaypanel'
import ColorPicker from 'primevue/colorpicker'
import Inplace from 'primevue/inplace'
import Carousel from 'primevue/carousel'

import Dialog from 'primevue/dialog'
import Menu from 'primevue/menu'
import Menubar from 'primevue/menubar'
import Avatar from 'primevue/avatar'
import Tooltip from 'primevue/tooltip'
import Column from 'primevue/column'
import Sidebar from 'primevue/sidebar'
import Slider from 'primevue/slider'
import RadioButton from 'primevue/radiobutton'
import Divider from 'primevue/divider'
import FileUpload from 'primevue/fileupload'
import Badge from 'primevue/badge'
import Paginator from 'primevue/paginator';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import ProgressBar from 'primevue/progressbar';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmationService from 'primevue/confirmationservice';
import Image from 'primevue/image';
import Stepper from 'primevue/stepper';
import StepperPanel from 'primevue/stepperpanel';
import Tag from 'primevue/tag';
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon';
import DataView from 'primevue/dataview';
import DataTable from 'primevue/datatable';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions'
import ProgressSpinner from "primevue/progressspinner";
import TabView from "primevue/tabview"
import TabPanel from "primevue/tabpanel"
import Fieldset from "primevue/fieldset"
import PanelMenu from "primevue/panelmenu"
import Listbox from "primevue/listbox"
import MultiSelect from "primevue/multiselect"
import Calendar from "primevue/calendar"
import Editor from "primevue/editor"

import {slideWidget, slideWidgetNoShadow} from "@/slideWidget";
import {calculatorWidget} from "@/calculatorWidget";
import useMicroservice from "@/hooks/useMicroservice";
import Skeleton from "primevue/skeleton";
import {PrimeIcons} from "primevue/api";
import Hotjar from 'vue-hotjar';
import {thumbnailWidget} from "@/thumbnailWidget";
// import 'primevue/resources/themes/aura-light-indigo/theme.css'
//import './registerServiceWorker'
import {showToast} from '@/utils/showToast'

import formula from '@jspreadsheet/formula-pro'

formula.license('ZWQ0ZmVhMGRjM2JhN2M1N2ExNGFjYzZjNGQ2MzQyM2VlMmYxZTU5ZTZiMTg1ZWU3ZjkyZTA0NjkzZDFkOWVlNjgxMGYwODJiNWU3YTRiMjkyYTU1ODE4ZThhYzZlZTg5NDdmNTVhODAwOGQ3NjQ5ZDFiMDdlZDg4OTUyODcxMDUsZXlKamJHbGxiblJKWkNJNklqSmhaRGsyWTJNeE5tVTJNalV3TVRjek1qZGlPV0ZoT0RjM1ltSmtaR1ppTXpVek1tRTNNVGdpTENKdVlXMWxJam9pVW1GeGRXVnNJRWRoY21OcFlTSXNJbVJoZEdVaU9qRTNOams0TVRjMk1EQXNJbVJ2YldGcGJpSTZXeUpzWlhabGNtRm5aWEJ2YVc1MExtTnZiU0lzSWpFeU55NHdMakF1TVNJc0lteHZZMkZzYUc5emRDSXNJbmRsWWlJc0lteHZZMkZzYUc5emRDSmRMQ0p3YkdGdUlqb2lNek1pTENKelkyOXdaU0k2V3lKMk55SXNJblk0SWl3aWRqa2lMQ0oyTVRBaUxDSjJNVEVpTENKbWIzSnRkV3hoSWl3aVptOXliWE1pTENKeVpXNWtaWElpTENKd1lYSnpaWElpTENKcGJYQnZjblJsY2lJc0luWmhiR2xrWVhScGIyNXpJaXdpWTI5dGJXVnVkSE1pTENKelpXRnlZMmdpTENKamFHRnlkSE1pWFgwPQ')
formula.adjustPrecision = true


const registerComponents = (app: any) => {
    const components = [
        DataView,
        DataTable,
        DataViewLayoutOptions,
        Button,
        InputNumber,
        Dropdown,
        SelectButton,
        Fieldset,
        ToggleButton,
        ProgressSpinner,
        InputSwitch,
        InputText,
        Carousel,
        InputGroup,
        PanelMenu,
        InputIcon,
        InputGroupAddon,
        Checkbox,
        ConfirmDialog,
        Textarea,
        AutoComplete,
        Toolbar,
        OverlayPanel,
        ColorPicker,
        Inplace,
        Dialog,
        Menubar,
        Avatar,
        Sidebar,
        Slider,
        RadioButton,
        IconField,
        Divider,
        FileUpload,
        Badge,
        Paginator,
        Accordion,
        AccordionTab,
        Skeleton,
        ProgressBar,
        Toast,
        Image,
        Stepper,
        StepperPanel,
        Tag,
        Menu,
        Column,
        TabView,
        Chip,
        TabPanel,
        Listbox,
        MultiSelect,
        Calendar,
        VueTimepicker,
        Editor
    ];

    components.forEach((component) => app.component(component.name, component));
}

(async () => {
    const publicCalculator = document.querySelectorAll('lpi-calculator');
    if (publicCalculator.length > 0) {
        customElements.define('lpi-calculator', calculatorWidget)
    } else if(window['lpi-template-loaded']) {
        customElements.define('value-prop-slide', slideWidget)
        customElements.define('value-prop-slide-open', slideWidgetNoShadow)
    } else {
        const app = createApp(App)

        registerComponents(app)

        app.component('PrimeMenu', Menu)

        app.directive('tooltip', Tooltip);

        app.use(Icon)
        app.use(i18nCountries)
        app.use(Directive)
        app.use(VueCookies)
        app.use(PrimeVue)
        app.use(ToastService)
        app.use(ConfirmationService);

        document.addEventListener('hotjar', (event) => {
            const { allUser } = event.detail
            if (allUser) {
                app.use(Hotjar, {
                    id: import.meta.env.VITE_APP_ALL_USER_HOTJAR_ID
                })
            }
            else {
                app.use(Hotjar, {
                    id: import.meta.env.VITE_APP_LPI_USER_HOTJAR_ID
                })
            }
        })

        const pinia = createPinia()
        app.use(pinia)
        app.use(router())
        customElements.define('thumb-nail', thumbnailWidget)
        app.mount('#app');
    }
})();
